import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import SizeBtn from './SizeBtn';
import FontKeys from '../FontKeys';

export default class SizePicker extends Phaser.GameObjects.Container {

  constructor (scene) {
    super(scene);

    this.sizeButtons = null;

    const sizePickerBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._size_select_bg, this).setOrigin(0);

    const sizePickerText = ABCyaPhaser.Text.addText(71, 8, 18, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('size_label'), this, false).setOrigin(0.5);

    this.sizeButtons = this.createSizeButtons(['small','medium','large']);
    let i = 0;
    const spacing = (sizePickerBg.getBounds().width - (this.sizeButtons[0].sizeBtnWidth * this.sizeButtons.length)) / (this.sizeButtons.length + 1);
    while (i < this.sizeButtons.length) {
      this.sizeButtons[i].x = spacing + ((this.sizeButtons[i].sizeBtnWidth + spacing) * i);
      this.sizeButtons[i].y = 20;
      this.add(this.sizeButtons[i]);

      this.sizeButtons[i].on(SizeBtn.SIZE_SELECT, (sizeId) => {
        this.emit(SizeBtn.SIZE_SELECT, sizeId);
      });
      i++;
    }

    this.sizeButtons[0].setSelected(true);
  };

  createSizeButtons(ids) {
    const btns = [];
    while (btns.length < ids.length) {
      const sizeBtn = new SizeBtn(this.scene, ids[btns.length], 36);
      btns.push(sizeBtn);
    }

    return btns;
  };
}